import { combineReducers } from 'redux';

// Front
import Layout from './layout/reducer';

// Authentication Module
import Account from './auth/register/reducer';
import Login from './auth/login/reducer';
import Forget from './auth/forgetpwd/reducer';

// Charger Management Module
import ChargerManagement from './chargers/reducer';
import LocationManagement from './locations/reducer';
import sharedData from './dbFilter/reducer';
import UserManagement from './users/reducer';
import HostTechManagement from './hostTech/reducer';


const rootReducer = combineReducers({

    // public
    Layout,

    // Authentication
    Account,
    Login,
    Forget,

    //charger and location inf0
    ChargerManagement,
    LocationManagement,
    UserManagement,
    HostTechManagement,
    sharedData,

});

export default rootReducer;